import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { DashboarduiService } from '../Shared/Service/dashboardui.service';
import { LocalstorageService } from '../Shared/Service/localstorage.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
export class idsProductList {
  id: number;
  status: String;
  hotelName: String;
  accountingDate: any;
  pusheddate: any;
  type: any
}
@Component({
  selector: 'app-generalcrm',
  templateUrl: './generalcrm.component.html',
  styleUrls: ['./generalcrm.component.css']
})
export class GeneralcrmComponent implements OnInit {
  isProgressing: boolean;
  apiresult: any;
  dropdownSettingsDept: IDropdownSettings = {};
  selectedDeptItems: any;
  dropdownDeptData: any
  pmscodedropdownDeptData:any;
  errorMsgSubscription: boolean;
  errorMessage: string;
  displayContent: boolean;
  partnerValue: any;
  idsProductList: idsProductList[] = [];
  dataSource!: MatTableDataSource<idsProductList>;
  // dataSource: any = [];
  @ViewChild(MatPaginator, { static: true })
  paginator!: MatPaginator;
  @ViewChild(MatSort, { static: true })
  sort!: MatSort;
  filterProperty: any;
  Val: any;
  pmscodevalue:any;
  selectedpmscode:any;
  constructor(private toastr: ToastrService, public router: Router, private apiCallIdsService: DashboarduiService, private datePipe: DatePipe, private localStorage: LocalstorageService) { }
  displayedColumns: string[] = ['ReservationReceived', 'ReservationPulled', 'ReceivedCheckedIn', 'PulledCheckedIn', 'ReceivedCheckedOut', 'PulledCheckedOut', 'lastHeartbeat']; /* ,'ReceivedPastCheckedOut','PulledPastCheckedOut' ' *//*hotelName',--remove the hotelName Indhuja 18-02-2025 */
  ngOnInit() {
    this.isProgressing = true;
    this.errorMsgSubscription = true
    this.errorMessage = "Please select Partner name and Property and load"
    this.displayContent = false
    this.callCRMList();
    this.dropdownSettingsDept = {
      idField: 'partnerCode',
      textField: 'partner',
      allowSearchFilter: true,
      singleSelection: true,
      enableCheckAll: false,
      closeDropDownOnSelection: true,
      itemsShowLimit: 7,
      noDataAvailablePlaceholderText: 'No Data Found',
      searchPlaceholderText: "Search Partner Name"
    };
  }

  callCRMList() {
    this.apiCallIdsService.getCRMList()
      .subscribe(
        data => {
          console.log('New Screen Data', data)
          this.apiresult = data;
          this.dropdownDeptData = this.apiresult
          console.log('dropdownDeptData =', this.dropdownDeptData)
          this.isProgressing = false;
        },
      );
  }

  changePropertySearch() {
    // console.log('selectedDeptItems = ',this.selectedDeptItems)
    if (this.selectedDeptItems) {
      if (this.selectedDeptItems.length > 0) {
        console.log('if condition')
        console.log('selectedDeptItems = ', this.selectedDeptItems)
        this.errorMsgSubscription = true
        this.errorMessage = "Please select Partner name and Property and load"
        this.displayContent = false
        this.partnerValue = this.selectedDeptItems[0].partner
        console.log('pms code value = ', this.partnerValue)
        this.getCRMPropertyList();
      } else {
        console.log('Else condition zero')
        this.errorMsgSubscription = true
        this.errorMessage = "Please select Partner name and Property and load"
        this.displayContent = false
      }
    } else {
      console.log('Property Not Selected')
    }
  }

  loadMethod() {
    this.isProgressing = true
    this.apiCallIdsService.readCRMReadAPIData(this.partnerValue,this.pmscodevalue)
      .subscribe(
        data => {
          console.log('New Screen Data', data)
          if (data.length > 0) {
            this.errorMsgSubscription = false
            this.displayContent = true
            this.idsProductList = data;
            this.filterProperty = this.idsProductList
            this.dataSource = new MatTableDataSource(this.idsProductList);
            this.dataSource.paginator = this.paginator;
            this.toastr.success('Data Loaded Successfully');
            this.isProgressing = false;
          } else {
            this.displayContent = false
            this.errorMsgSubscription = true
            this.errorMessage = "No Data Found"
            this.toastr.error('No Data Found');
            this.isProgressing = false;
          }
        },
      );
  }

  getCRMPropertyList(){
    this.isProgressing = true
    console.log("partnername",this.partnerValue)
    this.apiCallIdsService.getCRMPropertyList(this.partnerValue)
    .subscribe(
      data => {
        console.log('New Screen Data', data)
        this.apiresult = data;
        this.pmscodedropdownDeptData = this.apiresult
        console.log("selected pmscode",this.selectedpmscode);
        console.log('pms code value list = ', this.pmscodevalue)
        console.log('pmscodedropdownDeptData =', this.pmscodedropdownDeptData)
        this.isProgressing = false;
      },
    );
  }
  onPmsCodeChange(event: any) {
    this.pmscodevalue=event.value;
    console.log('Selected PMS Code:', this.pmscodevalue);
  }
  Search(event: any) {
    console.log('event= ', event)
    this.dataSource = this.filterProperty.filter((res: { hotelName: { toString: () => string; } }) => {
      return res.hotelName.toString().toLocaleLowerCase().match(this.Val.toLocaleLowerCase())
    });
    if (event == '') {
      this.Val = '';
    }
  }
}
